import { useState, useEffect, useRef, useLayoutEffect } from "react";
import TechNoteService from "src/Services/API/technote.service";
import { formatDate, getAvatarUrl, getImageUrl } from "src/Common/common";
import UserService from "src/Services/API/user.service";

const TechNotes = ({ woId }) => {
  const currentUser = UserService.getCurrentUser();
  const [techNotes, setTechNotes] = useState([]);
  const [note, setNote] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [editingNoteId, setEditingNoteId] = useState(null);
  const [editingText, setEditingText] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);
  const editingTextareaRef = useRef(null);

  useEffect(() => {
    if (woId) {
      getTechNotes(woId);
    }
  }, [woId]);

  const getTechNotes = async (workOrderId) => {
    try {
      const response = await TechNoteService.findAll(workOrderId);
      setTechNotes(response.data);
    } catch (error) {
      console.log("Error getting tech notes: ", error);
    }
  };

  const sendTechNote = async () => {
    const trimmedNote = note.trim();
    if (!trimmedNote || !woId || isSending) {
      return;
    }

    try {
      setIsSending(true);
      const response = await TechNoteService.create({
        woId,
        createdById: currentUser.id,
        note: trimmedNote,
      });
      setTechNotes([...techNotes, response.data]);
      setNote("");
    } catch (error) {
      console.log("Error creating tech note: ", error);
    } finally {
      setIsSending(false);
    }
  };

  const autoResizeEditingTextarea = () => {
    const textarea = editingTextareaRef.current;
    if (!textarea) {
      return;
    }
    textarea.style.height = "auto";
    textarea.style.height = `${textarea.scrollHeight}px`;
  };

  useLayoutEffect(() => {
    autoResizeEditingTextarea();
  }, [editingText, editingNoteId]);

  const handleEditClick = (techNote) => {
    if (editingNoteId === techNote.id) {
      return;
    }
    setEditingNoteId(techNote.id);
    setEditingText(techNote.note || "");
  };

  const saveTechNote = async (techNoteId) => {
    const trimmedNote = editingText.trim();
    if (!trimmedNote || isUpdating) {
      return;
    }

    try {
      setIsUpdating(true);
      const response = await TechNoteService.update(techNoteId, {
        note: trimmedNote,
      });
      const updatedNote = response.data;
      setTechNotes((prev) => prev.map((item) => (item.id === techNoteId ? updatedNote : item)));
      setEditingNoteId(null);
      setEditingText("");
    } catch (error) {
      console.log("Error updating tech note: ", error);
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <div>
      {techNotes.length === 0 && (
        <span className="font-family-OpenSansRegular text-[12px] text-gray-500">No tech notes</span>
      )}
      {techNotes.length > 0 && techNotes?.map((item) => (
        <div key={item.id} className="w-full flex items-start gap-2 mb-3">
          <div className="flex flex-col gap-1 min-w-[180px]">
            <span className="font-family-OpenSansRegular text-[12px] text-titleColor min-w-[140px]">
              {formatDate(item.createdAt)}
            </span>

            {item.updatedAt !== item.createdAt && (
              <span className="font-family-OpenSansRegular text-[11px] text-[#404A6E] min-w-[140px] italic">
                last edited {formatDate(item.updatedAt)}
              </span>
            )}
          </div>
          <div className="flex items-center gap-1 flex-auto">
            {editingNoteId === item.id ? (
              <textarea
                ref={editingTextareaRef}
                value={editingText}
                onChange={(e) => setEditingText(e.target.value)}
                rows={1}
                className="w-full border-solid border-[1px] border-borderColor rounded-[7px] px-2 py-1 font-family-OpenSansRegular text-[12px] text-titleColor resize-none"
              />
            ) : (
              <span className="font-family-OpenSansRegular text-[12px] text-titleColor flex-auto">{item.note}</span>
            )}
            {/* {item.createdBy.id === currentUser.id && (
              <EditButton
                clicked={() => (editingNoteId === item.id ? saveTechNote(item.id) : handleEditClick(item))}
                isEditing={editingNoteId === item.id}
                isDisabled={(editingNoteId !== null && editingNoteId !== item.id) || isUpdating}
              />
            )} */}
          </div>
          <div className="flex items-center gap-2 min-w-[180px]">
            <img src={getAvatarUrl(item.createdBy.avatar)} className="w-[24px] rounded-[12px]" />
            <span className="font-family-OpenSansRegular text-[12px] text-titleColor">
              {item.createdBy.name}
            </span>
          </div>
        </div>
      ))}

      {/* <textarea
        value={note}
        onChange={(e) => setNote(e.target.value)}
        placeholder="Write a note"
        rows={3}
        className="w-full border-solid border-[1px] border-borderColor rounded-[7px] p-3 font-family-OpenSansRegular text-[12px] text-titleColor resize-none"
      />
      <div className="w-full flex items-center justify-end mt-2 ">
        <button
          type="button"
          onClick={sendTechNote}
          disabled={isSending || note.trim() === ""}
          className="uppercase border-solid border-[1px] border-borderColor rounded-[6px] px-5 py-2 font-family-OpenSansRegular text-[14px] leading-none text-titleColor disabled:opacity-50 disabled:cursor-not-allowed"
        >
          ADD NOTE
        </button>
      </div> */}
    </div>
  );
};

export default TechNotes;

const EditButton = ({ clicked, isEditing = false, isDisabled = false }) => {
  return (
    isEditing ? (
      <div onClick={clicked} className="min-w-[18px] cursor-pointer">
        <img src={getImageUrl("/images/common/check.png")} className="w-[18px]" />
      </div>
    ) : (
      <div
        onClick={isDisabled ? undefined : clicked}
        className={`min-w-[18px] ${isDisabled ? "cursor-not-allowed opacity-40" : "cursor-pointer"}`}
      >
        <img src={getImageUrl("/images/common/blueedit.png")} className="w-[18px]" />
      </div>
    )
  );
};
